export const staffSearchAction = "STAFF/SEARCH/LIST";
export const staffSearchSuccessAction = "STAFF/SEARCH/LIST/SUCCESS";
export const staffSearchFailAction = "STAFF/SEARCH/LIST/FAIL";
export const staffSearchResetAction = "STAFF/SEARCH/LIST/RESET";
